export default function cleanUrl(url) {
  return url
    .replace(/^(https?|http):\/\//,"")
    .replace(/[^=&]+=(&|$)/g,"")
    .replace(/&$/,"")
    .replace(/\/$/, "")
}
